import { useTranslation } from 'react-i18next';
import { CurrencyCode, PricingUnit, MonetaryAmount } from '@steelbuy/ts-shared';
import { FormItem, Validator } from '@steelbuy/ui-primitive';
import { MonetaryAmountInput } from '../monetary-amount-input/MonetaryAmountInput';
import { GenericValidationProps } from '../validation/Validation';

type MaterialPriceInputProps = {
    initialPrice?: MonetaryAmount;
    setPrice: (newPrice?: MonetaryAmount) => void;
    priceCurrencyCode: CurrencyCode;
    pricingUnit?: PricingUnit;
    header?: string;
    label?: string;
    name: string;
    description?: string;
    validators?: Validator[];
} & GenericValidationProps;

export const MaterialPriceInput = ({
    setPrice,
    forceValidation,
    required,
    priceCurrencyCode,
    initialPrice,
    pricingUnit = PricingUnit.TON,
    header,
    label,
    name,
    description,
    validators,
}: MaterialPriceInputProps) => {
    const { t } = useTranslation(['uiDomain', 'domainModel']);

    return (
        <FormItem
            header={
                header ||
                t('uiDomain:sellingPriceInput.formItemHeader', {
                    pricingUnit: t(`domainModel:material.pricingUnit.value.${pricingUnit}.label`),
                })
            }
            description={description}
            isMandatory={validators?.length === 2 || required}
        >
            <MonetaryAmountInput
                label={label || t('uiDomain:sellingPriceInput.inputLabel')}
                name={name}
                updateMonetaryAmount={setPrice}
                forceValidation={forceValidation}
                required={required}
                currencyCode={priceCurrencyCode}
                initialMonetaryAmount={initialPrice}
                pricingUnit={pricingUnit}
                validators={validators}
            />
        </FormItem>
    );
};
